import React from 'react';
import styled from 'styled-components';
import { color } from 'ui';
import { CredusText, CredusWrapper } from 'ui';
import {
  ReportScoreType,
  TestReportTableProps,
} from '../../report-models/report.interface';

const TestReportTable = ({ data }: TestReportTableProps) => {
  const mcq = data?.reportScore[1];
  const sc = data?.reportScore[0];
  const score = [
    {
      section: 'MCQ',
      ...mcq,
    },
    {
      section: 'SC',
      ...sc,
    },
  ];

  const totalScore = score.reduce((acc: number, current: ReportScoreType) => {
    return acc + current.score;
  }, 0);

  return (
    <CredusWrapper
      margin="2.5rem auto 0rem"
      padding="1.37rem 0rem"
      w="80%"
      bg="#F5F6F8"
    >
      <CredusWrapper w="90%" margin="auto">
        <CredusWrapper
          display="flex"
          align="center"
          justify="center"
          gap="1rem"
        >
          <CredusWrapper display="flex" align="center" w="7rem">
            <CredusText size="sm" weight="medium">
              Section
            </CredusText>
          </CredusWrapper>
          <CredusWrapper display="flex" align="center">
            <TextWrap size="sm" weight="medium">
              Point/q
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              Correct
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              InCorrect
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              Unanswered
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              Score
            </TextWrap>
          </CredusWrapper>
        </CredusWrapper>

        {score?.map((item, i) => (
          <CredusWrapper
            key={i}
            display="flex"
            align="center"
            justify="center"
            gap="1rem"
            mt="0.93rem"
          >
            <CredusWrapper display="flex" align="center" w="7rem">
              <CredusText size="md" weight="medium">
                {item.section}
              </CredusText>
            </CredusWrapper>
            <CredusWrapper
              display="flex"
              align="center"
              bg="#fff"
              justify="space-between"
              padding="0.75rem 0rem"
            >
              <TextWrap size="xl" weight="medium">
                {item?.totalPoint}
              </TextWrap>
              <TextWrap size="xl" weight="medium" color={color.tertiary}>
                {item?.correct}
              </TextWrap>
              <TextWrap size="xl" weight="medium" color={color.primary}>
                {item?.inCorrect}
              </TextWrap>
              <TextWrap size="xl" weight="medium" color="#FFB801">
                {item?.unanswered}
              </TextWrap>
              <TextWrap size="xl" weight="medium">
                {item.score}
              </TextWrap>
            </CredusWrapper>
          </CredusWrapper>
        ))}

        <CredusWrapper
          display="flex"
          mt="0.93rem"
          align="center"
          justify="center"
          gap="1rem"
        >
          <CredusWrapper display="flex" align="center" w="7rem">
            <CredusText size="sm" weight="medium">
              Total
            </CredusText>
          </CredusWrapper>
          <CredusWrapper display="flex" align="center">
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="xl" weight="medium">
              {totalScore}
            </TextWrap>
          </CredusWrapper>
        </CredusWrapper>
        <CredusWrapper
          display="flex"
          mt="0.93rem"
          align="center"
          justify="center"
          gap="1rem"
        >
          <CredusWrapper display="flex" align="center" w="7rem">
            <CredusText size="sm" weight="medium">
              Percentage%
            </CredusText>
          </CredusWrapper>
          <CredusWrapper display="flex" align="center">
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="sm" weight="medium">
              {' '}
            </TextWrap>
            <TextWrap size="xl" weight="medium" color={color.primary}>
              {data?.percentScore}%
            </TextWrap>
          </CredusWrapper>
        </CredusWrapper>
      </CredusWrapper>
    </CredusWrapper>
  );
};

export default TestReportTable;
const TextWrap = styled(CredusText)`
  width: 112px;
  text-align: center !important;
`;
